import o from "./_group.js";
var r = o(function (o, r, t) {
  o[t] = r;
});
export { r as default };